<template>
  <div>
    <div class="course-detail-container" :class="isMobile?'mobile-course-detail-container':''">
      <page-background/>
      <div class="course-detail-route">
        <router-link to="/">
          首页
        </router-link>
        <a-icon type="right"/>
        <span>直播详情</span>
      </div>
      <div class="box" :style="isMobile?{width:'90%',margin:'-100px auto 0'}:{}">
        <div>
          <course-introduce/>
        </div>

        <course-info-tab class="course-info-tab"/>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../../mixin/common";
import CourseIntroduce from "@views/live-online/components/CourseIntroduce"
import CourseInfoTab from "@views/live-online/components/CourseInfoTab";
import {DISPATH_LIVE_ONLINE_COURSE_INFO} from "@constants/action-type/course-live-online-action-type";

export default {
  mixins: [common],
  name: "CourseLiveOnlineDetail",
  components: {
    CourseIntroduce,
    CourseInfoTab
  },
  mounted() {
    this.$store.dispatch(DISPATH_LIVE_ONLINE_COURSE_INFO, {courseId: this.$route.params.courseId});
  },
  watch: {
    isLogin() {
      // 登录状态改变
      this.$store.dispatch(DISPATH_LIVE_ONLINE_COURSE_INFO, {courseId: this.$route.params.courseId});
    }
  }
}
</script>

<style scoped lang="less">
.course-detail-container {
  padding-bottom: 40px;
}
.box{
  margin-top: -100px;
}

// 课程详情页头
.course-detail-route {
  font-size: 16px;
  padding: 20px 0 15px 20px;
  margin: auto;
  color: #fff;
  width: 1200px;
  height: 164px;
  background-size: 100%;
  background: linear-gradient(90deg, #5782F6 0%, #4683FF 100%);;
  box-shadow: 0px 8px 10px 0px rgba(40,113,234,0.1);
  a{
    color: #fff;
  }
}

.course-info-tab {
  margin-top: 20px;
  border-radius: 3px;
}

// 移动端样式
.mobile-course-detail-container {
  padding-bottom: 70px;
}

</style>
